// components/common/ErrorDisplay.js
import Alert from 'react-bootstrap/Alert';

export const ErrorDisplay = ({ error, onDismiss }) => {
    if (!error) return null;

    return (
        <Alert variant="danger" dismissible onClose={onDismiss}>
            {error}
        </Alert>
    );
};